<template>
  <v-card
    v-bind="$attrs"
    tile
    :color="backgroundColor"
    :style="{display: 'flex', flexDirection: 'column'}"
    v-on="$listeners"
  >
    <v-card
      :color="color"
      class="v-card--material__header d-flex align-center"
      :style="color !== 'secondary' ? 'left: -1px; width: calc(100% + 1px); max-width: calc(100% + 1px);' : ''"
    >
      <slot
        v-if="!title && !text"
        name="header"
      />
      <div
        v-else
        class="px-3 py-2"
      >
        <h4
          class="title font-weight-light mb-2"
          v-text="title"
        />
        <v-spacer />
        <p
          class="category font-weight-thin mb-0"
          v-text="text"
        />
      </div>
    </v-card>
    <v-progress-linear
      v-if="loading"
      color="tertiary"
      :indeterminate="true"
      class="ma-0"
    />
    <v-card-text v-if="!noPadding">
      <slot />
    </v-card-text>
    <slot v-else />

    <v-card-actions
      v-if="$slots.actions"
      :class="noPadding ? 'grow ma-0 pa-0' : 'grow ma-2'"
      :style="{alignItems: 'flex-end'}"
    >
      <v-spacer v-if="!noPadding" />
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'MaterialCard',

    inheritAttrs: false,

    props: {
      color: {
        type: String,
        default: 'secondary',
      },
      backgroundColor: {
        type: String,
        default: null
      },
      html: {
        type: String,
        default: null,
      },
      loading: {
        type: Boolean,
      },
      elevation: {
        type: [Number, String],
        default: 10,
      },
      noPadding: {
        type: Boolean
      },
      inline: {
        type: Boolean,
        default: false,
      },
      fullWidth: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: undefined,
      },
      text: {
        type: String,
        default: undefined,
      },
    },
  }
</script>
